import { render, staticRenderFns } from "./OpportunityDashboardOpenCard.vue?vue&type=template&id=214cbfc4&scoped=true&"
import script from "./OpportunityDashboardOpenCard.vue?vue&type=script&lang=js&"
export * from "./OpportunityDashboardOpenCard.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityDashboardOpenCard.vue?vue&type=style&index=0&id=214cbfc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214cbfc4",
  null
  
)

export default component.exports